import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireAuth } from './guards';
import { routePatterns } from './paths';
import { TaskQueuePage } from '../pages/TaskQueuePage/index';
import { TaskDetailPage } from '../pages/TaskDetailPage';
import { TaskTypeInstructionsPage } from '../pages/TaskTypeInstructionsPage';
import { SettingsPage } from '../pages/SettingsPage';

function auth(element: React.ReactElement): React.ReactElement {
  return <RequireAuth>{element}</RequireAuth>;
}

export const workspaceRoutes: RouteObject[] = [
  { path: routePatterns.queue, element: auth(<TaskQueuePage />) },
  { path: routePatterns.task, element: auth(<TaskDetailPage />) },
  { path: routePatterns.instructions, element: auth(<TaskTypeInstructionsPage />) },
  { path: routePatterns.settings, element: auth(<SettingsPage />) },
];
